// "use client";
// import React from "react";
// import styles from "./InputDesign.module.css";
// import { useNavigate } from "react-router-dom";


// const Header = () => (
//   <header className={styles.header}>
//     <h1 className={styles.title}>Upload Resume</h1>
//     <h2 className={styles.subtitle}>(All document required to be upload)</h2>
//   </header>
// );

// const UploadSection = () => (
//   <section className={styles.uploadSection}>
//     <div className={styles.uploadBox}>
//       <h3 className={styles.uploadLabel}>Upload</h3>
//       <div className={styles.uploadArea}>
//         <span className={styles.uploadIcon}>
//           <i className="ti ti-cloud-upload" />
//         </span>
//         <p className={styles.dragText}>
//           Drag & drop files or{" "}
//           <button className={styles.browseLink}>Browse</button>
//         </p>
//         <p className={styles.supportedFormats}>
//           Supported formates: JPEG, PNG, GIF, MP4, PDF, PSD, AI, Word, PPT
//         </p>
//       </div>
//       <button className={styles.uploadButton}>Upload Files</button>
//     </div>
//   </section>
// );

// const ActionButton = ({ icon, text }) => (
//   <button className={styles.actionButton}>
//     <div dangerouslySetInnerHTML={{ __html: icon }} />
//     <span className={styles.span}>{text}</span>
//   </button>
// );

// const ActionButtons = () => (
  
//   <div className={styles.actionsSection}>
//     <div className={styles.actionButtons}>
//       <ActionButton
//         icon='<svg id="3684:28037" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon"> <path d="M17.25 13.1V20H5.25V8H12.15L13.65 6.5H3.75V21.5H18.75V11.6L17.25 13.1Z" fill="#5D52D9"></path> <path d="M13.125 14.225L10.5 14.75L11.025 12.125L18.45 4.7C19.05 4.1 19.95 4.1 20.55 4.7C21.15 5.3 21.15 6.2 20.55 6.8L13.125 14.225Z" stroke="#5D52D9" stroke-width="1.5" stroke-miterlimit="10"></path> </svg>'
//         text="Create Resume"
//         onClick={() => navigate("/crr")}

//       />
//       <ActionButton
//         icon='<svg id="3684:28042" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon"> <path d="M6.62071 3.78068C11.3825 4.07245 13.5328 3.67993 15.0331 3.67993C16.4284 3.67993 17.085 8.26849 16.5115 9.62347C15.9709 10.901 6.77043 10.9523 6.34208 10.4464C5.84675 9.86107 6.13314 7.41709 6.13314 6.57865" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M6.65011 11.9412C0.110618 17.9886 8.0252 16.9094 9.64418 18.2045" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M6.64941 11.9412C6.73711 13.3216 6.81945 16.4413 6.76539 16.8734" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M13.249 8.67488C13.249 8.41808 13.249 8.16122 13.249 7.9043" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M11.3879 8.7368C11.372 8.53352 11.3879 8.0678 11.3879 7.9043" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12.9531 15.0038C21.8751 14.8959 23.2421 14.1044 19.5007 21.0117" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M17.8832 21.2268C12.5588 21.0109 8.96121 22.9536 11.4435 16.3701" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M11.5509 21.2276C10.396 20.3839 9.1079 19.7135 7.98926 18.7812" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M13.8535 11.9094C13.8913 12.8338 13.9255 13.7539 13.9255 14.6795" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M13.8535 11.9094C14.3036 12.6223 14.728 13.0863 15.2564 14.3197" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M5.55689 7.64185C5.28582 7.71271 5.01278 7.69879 4.73633 7.72399" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M4.32518 7.06812C4.3288 7.56534 4.32508 8.05488 4.28418 8.54514" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M17.4141 7.437C17.6189 7.41576 17.8249 7.38906 18.0294 7.35498" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M18.2344 6.78125C18.2926 7.10687 18.2754 7.43705 18.2754 7.76591" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M14.2961 7.48846C12.9517 7.34008 11.6494 7.411 10.3574 7.61458" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> </svg>'
//         text="Generate Resume"
//       />
//     </div>
//     <div className={styles.actionButtonsSecondRow}>
//       <ActionButton
//         icon='<svg id="3684:28061" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon"> <path d="M9.75 9.5V15.5M6.75 12.5H12.75M16.25 10.5L18.8268 8.95392C19.6199 8.47803 20.0165 8.24009 20.3428 8.27051C20.6273 8.29703 20.8869 8.444 21.056 8.67433C21.25 8.93848 21.25 9.40095 21.25 10.3259V14.6741C21.25 15.599 21.25 16.0615 21.056 16.3257C20.8869 16.556 20.6273 16.703 20.3428 16.7295C20.0165 16.7599 19.6199 16.522 18.8268 16.0461L16.25 14.5M6.45 18.5H13.05C14.1701 18.5 14.7302 18.5 15.158 18.282C15.5343 18.0903 15.8403 17.7843 16.032 17.408C16.25 16.9802 16.25 16.4201 16.25 15.3V9.7C16.25 8.5799 16.25 8.01984 16.032 7.59202C15.8403 7.21569 15.5343 6.90973 15.158 6.71799C14.7302 6.5 14.1701 6.5 13.05 6.5H6.45C5.3299 6.5 4.76984 6.5 4.34202 6.71799C3.96569 6.90973 3.65973 7.21569 3.46799 7.59202C3.25 8.01984 3.25 8.57989 3.25 9.7V15.3C3.25 16.4201 3.25 16.9802 3.46799 17.408C3.65973 17.7843 3.96569 18.0903 4.34202 18.282C4.76984 18.5 5.32989 18.5 6.45 18.5Z" stroke="#5D52D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </svg>'
//         text="Create Video"
//         onClick={() => navigate("/video")}

//       />
//       <ActionButton
//         icon='<svg id="3684:28065" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon"> <path d="M12.25 17.5V21.5M12.25 21.5H9.25M12.25 21.5H15.25" stroke="#5D52D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M14.25 5.5C14.25 4.39543 13.3546 3.5 12.25 3.5C11.1454 3.5 10.25 4.39543 10.25 5.5V11.5C10.25 12.6046 11.1454 13.5 12.25 13.5C13.3546 13.5 14.25 12.6046 14.25 11.5V5.5Z" stroke="#5D52D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M17.9881 13.2542C17.6177 14.4659 16.8731 15.5292 15.8612 16.2917C14.8493 17.0543 13.6219 17.4769 12.355 17.499C11.0881 17.5211 9.84673 17.1416 8.8088 16.4148C7.77087 15.688 6.98967 14.6514 6.57715 13.4534" stroke="#5D52D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </svg>'
//         text="Create Audio"
//       />
//     </div>
//     <div className={styles.illustration}>
//       <img
//         src="https://cdn.builder.io/api/v1/image/assets/TEMP/18da5b4fb6886f19971cdb14fc85b03c03355bd4"
//         alt="File management illustration"
//         loading="lazy"
//         className={styles.img}
//       />
//     </div>
//   </div>
// );

// const InputDesign = () => {
//   return (
//     <> 
//       <link
//         rel="stylesheet"
//         href="https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/dist/tabler-icons.min.css"
//       />
//       <link
//         rel="stylesheet"
//         href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap"
//       />
//       <main className={styles.uploadContainer}>
//         <Header />
//         <div className={styles.contentWrapper}>
//           <UploadSection />
//           <ActionButtons />
//         </div>
//       </main>
//     </>
//   );
// };

// export default InputDesign;

"use client";
import React from "react";
import { useNavigate } from "react-router-dom"; // ✅ Import for React Router navigation
import styles from "./InputDesign.module.css";

const Header = () => (
  <header className={styles.header}>
    <h1 className={styles.title}>Upload Resume</h1>
    <h2 className={styles.subtitle}>(All document required to be upload)</h2>
  </header>
);

const UploadSection = () => (
  <section className={styles.uploadSection}>
    <div className={styles.uploadBox}>
      <h3 className={styles.uploadLabel}>Upload</h3>
      <div className={styles.uploadArea}>
        <span className={styles.uploadIcon}>
          <i className="ti ti-cloud-upload" />
        </span>
        <p className={styles.dragText}>
          Drag & drop files or{" "}
          <button className={styles.browseLink}>Browse</button>
        </p>
        <p className={styles.supportedFormats}>
          Supported formats: JPEG, PNG, GIF, MP4, PDF, PSD, AI, Word, PPT
        </p>
      </div>
      <button className={styles.uploadButton}>Upload Files</button>
    </div>
  </section>
);

// ✅ Updated ActionButton to accept onClick
const ActionButton = ({ icon, text, onClick }) => (
  <button className={styles.actionButton} onClick={onClick}>
    <div dangerouslySetInnerHTML={{ __html: icon }} />
    <span className={styles.span}>{text}</span>
  </button>
);

const ActionButtons = () => {
  const navigate = useNavigate(); // ✅ Use useNavigate inside the component

  return (
    <div className={styles.actionsSection}>
    <div className={styles.actionButtons}>
      <ActionButton
        icon='<svg id="3684:28037" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon"> <path d="M17.25 13.1V20H5.25V8H12.15L13.65 6.5H3.75V21.5H18.75V11.6L17.25 13.1Z" fill="#5D52D9"></path> <path d="M13.125 14.225L10.5 14.75L11.025 12.125L18.45 4.7C19.05 4.1 19.95 4.1 20.55 4.7C21.15 5.3 21.15 6.2 20.55 6.8L13.125 14.225Z" stroke="#5D52D9" stroke-width="1.5" stroke-miterlimit="10"></path> </svg>'
        text="Create Resume"
        onClick={() => navigate("/crr")}

      />
      <ActionButton
        icon='<svg id="3684:28042" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon"> <path d="M6.62071 3.78068C11.3825 4.07245 13.5328 3.67993 15.0331 3.67993C16.4284 3.67993 17.085 8.26849 16.5115 9.62347C15.9709 10.901 6.77043 10.9523 6.34208 10.4464C5.84675 9.86107 6.13314 7.41709 6.13314 6.57865" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M6.65011 11.9412C0.110618 17.9886 8.0252 16.9094 9.64418 18.2045" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M6.64941 11.9412C6.73711 13.3216 6.81945 16.4413 6.76539 16.8734" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M13.249 8.67488C13.249 8.41808 13.249 8.16122 13.249 7.9043" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M11.3879 8.7368C11.372 8.53352 11.3879 8.0678 11.3879 7.9043" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12.9531 15.0038C21.8751 14.8959 23.2421 14.1044 19.5007 21.0117" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M17.8832 21.2268C12.5588 21.0109 8.96121 22.9536 11.4435 16.3701" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M11.5509 21.2276C10.396 20.3839 9.1079 19.7135 7.98926 18.7812" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M13.8535 11.9094C13.8913 12.8338 13.9255 13.7539 13.9255 14.6795" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M13.8535 11.9094C14.3036 12.6223 14.728 13.0863 15.2564 14.3197" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M5.55689 7.64185C5.28582 7.71271 5.01278 7.69879 4.73633 7.72399" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M4.32518 7.06812C4.3288 7.56534 4.32508 8.05488 4.28418 8.54514" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M17.4141 7.437C17.6189 7.41576 17.8249 7.38906 18.0294 7.35498" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M18.2344 6.78125C18.2926 7.10687 18.2754 7.43705 18.2754 7.76591" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M14.2961 7.48846C12.9517 7.34008 11.6494 7.411 10.3574 7.61458" stroke="#1F00AD" stroke-width="0.96" stroke-linecap="round" stroke-linejoin="round"></path> </svg>'
        text="Generate Resume"
      />
    </div>
    <div className={styles.actionButtonsSecondRow}>
      <ActionButton
        icon='<svg id="3684:28061" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon"> <path d="M9.75 9.5V15.5M6.75 12.5H12.75M16.25 10.5L18.8268 8.95392C19.6199 8.47803 20.0165 8.24009 20.3428 8.27051C20.6273 8.29703 20.8869 8.444 21.056 8.67433C21.25 8.93848 21.25 9.40095 21.25 10.3259V14.6741C21.25 15.599 21.25 16.0615 21.056 16.3257C20.8869 16.556 20.6273 16.703 20.3428 16.7295C20.0165 16.7599 19.6199 16.522 18.8268 16.0461L16.25 14.5M6.45 18.5H13.05C14.1701 18.5 14.7302 18.5 15.158 18.282C15.5343 18.0903 15.8403 17.7843 16.032 17.408C16.25 16.9802 16.25 16.4201 16.25 15.3V9.7C16.25 8.5799 16.25 8.01984 16.032 7.59202C15.8403 7.21569 15.5343 6.90973 15.158 6.71799C14.7302 6.5 14.1701 6.5 13.05 6.5H6.45C5.3299 6.5 4.76984 6.5 4.34202 6.71799C3.96569 6.90973 3.65973 7.21569 3.46799 7.59202C3.25 8.01984 3.25 8.57989 3.25 9.7V15.3C3.25 16.4201 3.25 16.9802 3.46799 17.408C3.65973 17.7843 3.96569 18.0903 4.34202 18.282C4.76984 18.5 5.32989 18.5 6.45 18.5Z" stroke="#5D52D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </svg>'
        text="Create Video"
        onClick={() => navigate("/video")}

      />
      <ActionButton
        icon='<svg id="3684:28065" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon"> <path d="M12.25 17.5V21.5M12.25 21.5H9.25M12.25 21.5H15.25" stroke="#5D52D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M14.25 5.5C14.25 4.39543 13.3546 3.5 12.25 3.5C11.1454 3.5 10.25 4.39543 10.25 5.5V11.5C10.25 12.6046 11.1454 13.5 12.25 13.5C13.3546 13.5 14.25 12.6046 14.25 11.5V5.5Z" stroke="#5D52D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M17.9881 13.2542C17.6177 14.4659 16.8731 15.5292 15.8612 16.2917C14.8493 17.0543 13.6219 17.4769 12.355 17.499C11.0881 17.5211 9.84673 17.1416 8.8088 16.4148C7.77087 15.688 6.98967 14.6514 6.57715 13.4534" stroke="#5D52D9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </svg>'
        text="Create Audio"
      />
    </div>
    <div className={styles.illustration}>
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/18da5b4fb6886f19971cdb14fc85b03c03355bd4"
        alt="File management illustration"
        loading="lazy"
        className={styles.img}
      />
    </div>
  </div>
  );
};

const InputDesign = () => {
  return (
    <>
      <main className={styles.uploadContainer}>
        <Header />
        <div className={styles.contentWrapper}>
          <UploadSection />
          <ActionButtons />
        </div>
      </main>
    </>
  );
};

export default InputDesign;
